"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudioVideoUplinkBandwidthPolicy = void 0;
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
var _feature = require("@studio/feature.flags");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Custom video uplink bandwidth policy based on Chime SDK default NScaleVideoUplinkBandwidthPolicy
 * The reason we need a custom policy is to be able to configure the video resolution being sent (which
 * is a function of no. of participants who have turned on their videos)
 * It's governed by the targetHeightArray [https://github.com/aws/amazon-chime-sdk-js/blob/main/src/videouplinkbandwidthpolicy/NScaleVideoUplinkBandwidthPolicy.ts#L22]
 * Currently, SDK doesn't provide a way to change this, so we need to extend this class.
 * This class overrides only 2 methods from the parent class:
 * calculateEncodingParameters:: to make it work with our own custom targetHeightArray
 * maxBandwidthKbps:: to make it work with our own custom max bandwidth calculation
 */
var StudioVideoUplinkBandwidthPolicy = exports.StudioVideoUplinkBandwidthPolicy = /*#__PURE__*/function (_NScaleVideoUplinkBan) {
  _inherits(StudioVideoUplinkBandwidthPolicy, _NScaleVideoUplinkBan);
  var _super = _createSuper(StudioVideoUplinkBandwidthPolicy);
  function StudioVideoUplinkBandwidthPolicy() {
    var _this;
    _classCallCheck(this, StudioVideoUplinkBandwidthPolicy);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * Default expected target height (i.e. resolution) is 720p
     * as set with meetingSession.audioVideo.chooseVideoInputQuality
     */
    _defineProperty(_assertThisInitialized(_this), "expectedTargetHeight", 720);
    /**
     * UplinkPriority means this presenter is on-stage and needs to have higher resolution than targetHeightArray will allow
     * We are not using hasBandwidthPriority here because we want more flexibility
     * Setting hasBandwidthPriority entirely skips the targetHeightArray calculation and send max resolution
     * We want to be able to control this and choose what resolution we should send
     * That's why introducing this new flag here
     * e.g. setting hasBandwidthPriority will send 720p which might be too high if there's more than 1 speaker on stage
     */
    _defineProperty(_assertThisInitialized(_this), "hasUplinkPriority", false);
    /**
     * Resolution to use when uplink priority is set
     * It can be either of 720 or 540
     */
    _defineProperty(_assertThisInitialized(_this), "uplinkPriorityResolution", 540);
    return _this;
  }
  _createClass(StudioVideoUplinkBandwidthPolicy, [{
    key: "setHasUplinkPriority",
    value: function setHasUplinkPriority(hasUplinkPriority) {
      this.hasUplinkPriority = hasUplinkPriority;
    }
  }, {
    key: "calculateEncodingParameters",
    value: function calculateEncodingParameters(setting) {
      var maxBitrate = this.maxBandwidthKbps() * 1000;
      var scale = 1;
      var targetHeight = 720;

      /**
       * Use the custom targetHeightArray only if feature flag is set
       * otherwise use the default one from SDK
       */
      var targetHeightArray = (0, _feature.shouldHaveFeature)('studio.customVideoUplinkPolicy') ? StudioVideoUplinkBandwidthPolicy.targetHeightArray : _amazonChimeSdkJs.NScaleVideoUplinkBandwidthPolicy.targetHeightArray;
      if (setting.height !== undefined && setting.width !== undefined && this.scaleResolution && !this.hasBandwidthPriority && this.getNumberOfPublishedVideoSources() > 2) {
        var _this$browserBehavior, _this$logger;
        targetHeight = targetHeightArray[Math.min(this.getNumberOfPublishedVideoSources(), targetHeightArray.length - 1)][this.enableHighResolutionFeature ? 1 : 0];
        if (this.hasUplinkPriority) {
          targetHeight = Math.max(targetHeight, this.uplinkPriorityResolution);
        }
        if (targetHeight === 480 && (_this$browserBehavior = this.browserBehavior) !== null && _this$browserBehavior !== void 0 && _this$browserBehavior.disable480pResolutionScaleDown()) {
          targetHeight = 360;
        }
        scale = Math.max(Math.min(setting.height, setting.width) / targetHeight, 1);
        (_this$logger = this.logger) === null || _this$logger === void 0 || _this$logger.info("Resolution scale factor is ".concat(scale, " for capture resolution ").concat(setting.width, "x").concat(setting.height, ". New dimension is ").concat(setting.width / scale, "x").concat(setting.height / scale));
      }
      this.expectedTargetHeight = targetHeight;
      if (this.enableSVC) {
        var _this$logger2;
        var scalabilityMode;
        if (this.numParticipants >= 0 && this.numParticipants < 3 || !this.isUsingSVCCodec) {
          scalabilityMode = 'L1T1';
        } else {
          scalabilityMode = 'L3T3';
        }
        (_this$logger2 = this.logger) === null || _this$logger2 === void 0 || _this$logger2.info("calculateEncodingParameters: SVC: ".concat(this.enableSVC, " participants: ").concat(this.numParticipants, " publishers: ").concat(this.getNumberOfPublishedVideoSources(), " bitrate: ").concat(maxBitrate, " targetHeight: ").concat(targetHeight, " scalabilityMode: ").concat(scalabilityMode, " isUsingSVCCodec: ").concat(this.isUsingSVCCodec));
        return {
          scaleResolutionDownBy: scale,
          maxBitrate: maxBitrate,
          scalabilityMode: scalabilityMode
        };
      } else {
        return {
          scaleResolutionDownBy: scale,
          maxBitrate: maxBitrate
        };
      }
    }
  }, {
    key: "maxBandwidthKbps",
    value: function maxBandwidthKbps() {
      if (this.hasBandwidthPriority) {
        return Math.trunc(this.idealMaxBandwidthKbps);
      }

      /**
       * If uplink priority is set, we'll use maxBandwidthKbps for 720 or 540 resolution
       */
      if (this.hasUplinkPriority) {
        if (this.uplinkPriorityResolution === 720) {
          return Math.trunc(this.idealMaxBandwidthKbps);
        } else {
          return 900;
        }
      }
      if (!(0, _feature.shouldHaveFeature)('studio.customVideoUplinkPolicy')) {
        return _get(_getPrototypeOf(StudioVideoUplinkBandwidthPolicy.prototype), "maxBandwidthKbps", this).call(this);
      }
      var rate = 0;
      if (this.getNumberOfPublishedVideoSources() <= 4) {
        rate = this.idealMaxBandwidthKbps;
      } else if (this.getNumberOfPublishedVideoSources() <= 6) {
        rate = 1100;
      } else if (this.getNumberOfPublishedVideoSources() <= 8) {
        rate = 900;
      } else if (this.getNumberOfPublishedVideoSources() <= 9) {
        rate = 800;
      } else if (this.getNumberOfPublishedVideoSources() <= 10) {
        rate = 700;
      } else {
        rate = (544 / 11 + 14880 / (11 * this.getNumberOfPublishedVideoSources())) / 600 * this.idealMaxBandwidthKbps;
      }
      return Math.trunc(rate);
    }
  }, {
    key: "getNumParticipants",
    value: function getNumParticipants() {
      return this.numParticipants;
    }
  }, {
    key: "getExpectedTargetHeight",
    value: function getExpectedTargetHeight() {
      return this.expectedTargetHeight;
    }
  }]);
  return StudioVideoUplinkBandwidthPolicy;
}(_amazonChimeSdkJs.NScaleVideoUplinkBandwidthPolicy);
/*
 * Custom resolutions as a function of no. of videos on in the meeting
 * Array index is the no. of videos on
 * We use the 1st index of each subarray as out target resolution (as 2nd index is for when we enable HD meetings)
 * Also, in the comments, we have the target max bandwidth we need to set in maxBandwidthKbps method
 * Since we only allow maximum 10 videos on, the values beyond 10 are irrevalant for us and are kept as it is
 */
_defineProperty(StudioVideoUplinkBandwidthPolicy, "targetHeightArray", [[0, 0],
// 0
[0, 0],
// 1
[0, 0],
// 2
[720, 1080],
// 3 at 1400kbps
[720, 1080],
// 4 at 1400kbps
[648, 720],
// 5 at 1100kbps
[648, 720],
// 6 at 1100kbps
[576, 648],
// 7 at 900kbps
[576, 648],
// 8 at 900kbps
[540, 576],
// 9 at 800kbps
[504, 540],
// 10 at 700kbps
[360, 480],
// 11
[360, 480],
// 12
[270, 360],
// 13
[270, 360],
// 14
[270, 360],
// 15
[270, 360],
// 16
[180, 270],
// 17
[180, 270],
// 18
[180, 270],
// 19
[180, 270],
// 20
[180, 270],
// 21
[180, 270],
// 22
[180, 270],
// 23
[180, 270],
// 24
[180, 270] // 25
]);